import {
    useEffect,
    useRef,
    useState
} from 'react';
import {
    Container,
    Options,
    Controls,
    BtnOpenSelection,
    LoadingProgress,
    WrapperOptions
} from './styled';
import {
    Alert,
    CheckBox,
    Modal,
    TransferClient
} from '../../components';
import {
    FiCheckCircle
} from "react-icons/fi";
import {
    IoMdClose
} from "react-icons/io";
import {
    PiDotsThreeCircleVerticalLight
} from "react-icons/pi";
import {
    useOutsideAlerter
} from '../../hooks';
import {
    initializeCustomerServiceLote,
    finishCustomerServiceLote
} from '../../service/serviceChat/customerService';
import { toast } from 'react-toastify';



export function SelectMultipleCustomerService(props) {

    const {
        isOpen,
        customersSelected,
        customerServicesAll,
        onClose,
        onOpen,
        onSelectAll,
        actions
    } = props;

    const [alertParameters, setAlertParameters] = useState({
        isOpen: false,
        title: "",
        onClickOption1: () => { },
        onClickOption2: () => { },
        body: () => { }
    });
    const [loading, setLoading] = useState({
        isOpen: false,
        title: "",
    });
    const [checkSelectAll, setCheckSelectAll] = useState(false);
    const [transferCustomerService, setTransferCustomerService] = useState(false);

    useEffect(() => {
        setCheckSelectAll(
            (customersSelected.length === customerServicesAll)
                ? true
                : false
        )
    }, [customersSelected, customerServicesAll]);

    const resetAlert = () => {
        setAlertParameters({
            isOpen: false,
            title: "",
            onClickOption1: () => { },
            onClickOption2: () => { },
            body: () => { }
        })
    };
    const resetAll = () => {
        setLoading({ isOpen: false, title: "" });
        resetAlert();
        onClose();
    };

    async function onCustomerServiceLoteAction(isInitialize) {
        resetAlert();
        setLoading({
            isOpen: true,
            title: (isInitialize)
                ? "Iniciando Atendimentos..."
                : "Finalizando Atendimentos..."
        });
        const { status, message } = (isInitialize)
            ? await initializeCustomerServiceLote(customersSelected)
            : await finishCustomerServiceLote(customersSelected)
        const typeAlert = (status === 200) ? 'success' : 'error'
        toast[typeAlert](
            `${(message)
                ? message
                : (`Erro ao ${(isInitialize)
                    ? 'Inicializar'
                    : 'Finalizar'
                    } Atendimentos'`)
            }`,
            {
                position: "top-center",
                theme: "colored",
            }
        );
        resetAll();
    };
    const handleAction = (action) => {
        resetAlert();
        const totalSelecionados = customersSelected.length;
        if (action === 'transfer') {
            setAlertParameters({
                isOpen: true,
                title: "Confirmar transferência",
                onClickOption1: () => {
                    resetAlert();
                    setTransferCustomerService(true);
                },
                onClickOption2: () => { resetAlert(); },
                body: () => (
                    <p>
                        {`Deseja realmente transferir ${totalSelecionados} atendimento${totalSelecionados !== 1 ? 's' : ''} selecionado${totalSelecionados !== 1 ? 's' : ''}?`}
                    </p>
                )
            });
            return;
        }
        const isInitialize = (action === 'initialize');
        setAlertParameters({
            isOpen: true,
            title: (isInitialize)
                ? "Iniciar Atendimentos"
                : "Finalizar Atendimentos",
            onClickOption1: () => { onCustomerServiceLoteAction(isInitialize) },
            onClickOption2: () => { resetAlert() },
            body: () => {
                return (
                    <p>
                        {`Deseja realmente ${(isInitialize) ? "inicializar" : "finalizar"
                            } os atendimento selecionados ?`}
                    </p>
                )
            },
        });
    };
    const Actions = () => {

        const [openActions, setOpenActions] = useState(false);
        const refInfoUser = useRef(null);

        useOutsideAlerter(refInfoUser, () => setOpenActions(false));

        return (
            <WrapperOptions ref={refInfoUser}>
                <span className='dot-Act'>
                    <PiDotsThreeCircleVerticalLight
                        className='icon--'
                        fontSize={'1.5rem'}
                        onClick={() => setOpenActions(!openActions)}
                    />
                </span>
                {(openActions) &&
                    <Options>
                        <ul>
                            {(actions?.initialize) &&
                                <li
                                    onClick={() => handleAction('initialize')}
                                >
                                    {`Iniciar Atendimento`}
                                </li>
                            }
                            {(actions?.transfer) &&
                                <li
                                    onClick={() => handleAction('transfer')}
                                >
                                    {`Transferir Atendimento`}
                                </li>
                            }
                            {(actions?.finish) &&
                                <li
                                    onClick={() => handleAction('finish')}
                                >
                                    {`Finalizar Atendimento`}
                                </li>
                            }
                        </ul>
                    </Options>
                }
            </WrapperOptions>
        );
    };

    return (
        <>
            <Container>
                {(isOpen)
                    ? (
                        <Controls>
                            <div>
                                <IoMdClose
                                    className='icl-'
                                    fontSize={'1.5rem'}
                                    onClick={() => onClose()}
                                />
                                <div>
                                    {`${customersSelected?.length} selecionado${customersSelected.length !== 1 ? 's' : ''}`}
                                </div>
                            </div>
                            <div>
                                <div>
                                    <span>
                                        {`selecionar todos`}
                                    </span>
                                    <CheckBox
                                        initialValue={checkSelectAll}
                                        onChange={(e) => onSelectAll(e)}
                                    />
                                </div>
                                {(customersSelected.length > 0) && (<Actions />)}
                            </div>
                        </Controls>
                    )
                    : (
                        <BtnOpenSelection onClick={() => onOpen()}>
                            <FiCheckCircle fontSize={'1.2rem'} />
                            {`selecionar`}
                        </BtnOpenSelection>
                    )
                }
            </Container>
            <Alert
                isOpen={alertParameters.isOpen}
                title={alertParameters.title}
                onClickOption1={alertParameters.onClickOption1}
                onClickOption2={alertParameters.onClickOption2}
            >
                <span className='alr-ms'>
                    {alertParameters.body()}
                </span>
            </Alert>
            <Modal
                title={`Transferir Atendimentos`}
                isOpen={transferCustomerService}
                close={() => setTransferCustomerService(false)}
            >
                {(transferCustomerService) &&
                    <TransferClient
                        customer={null}
                        customersIDs={customersSelected}
                        close={() => {
                            setTransferCustomerService(false)
                            onClose()
                        }}
                    />
                }
            </Modal>
            <LoadingProgress isOpen={loading.isOpen}>
                <div>
                    <div>
                        <span className='loader'></span>
                    </div>
                    <div>
                        <p>
                            {loading.title}
                        </p>
                    </div>
                </div>
            </LoadingProgress>
        </>
    );
}